import { render, staticRenderFns } from "./HomeFavoritesFolders.vue?vue&type=template&id=0f40e863&"
import script from "./HomeFavoritesFolders.vue?vue&type=script&lang=js&"
export * from "./HomeFavoritesFolders.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/normacs_web/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports